<template>
  <div class="buy_text">
    <div>
      <div>
        <table class="table1" cellpadding="0" cellspacing="0" style="border-collapse: collapse;">
          <thead>
            <tr>
              <th style="width:120px">类别</th>
              <th style="width:230px">数据与功能</th>
              <th style="width:220px">8E页面盒子<br>(信号监测、半自动)</th>
              <th style="width:220px">8C页面盒子+运行模组<br>(全自动)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowspan="8" class="ct">标配数据</td>
              <td>中国金融期货交易所*</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>上海期货交易所（含上期能源）</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>大连商品交易所</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>郑州商品交易所</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>广州期货交易所</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>上海证券交易所*</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>深圳证券交易所*</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>文华商品指数和系列板块指数</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td rowspan="4" class="ct">模型编写</td>
              <td>公式编写<br>(400+个函数，麦语言)</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>策略优化函数</td>
              <td><sup class="heng"></sup></td>
              <td>√</td>
            </tr>
            <tr>
              <td>资金头寸函数</td>
              <td><sup class="heng"></sup></td>
              <td>√</td>
            </tr>
            <tr>
              <td>模型加密函数</td>
              <td>√</td>
              <td>√</td>
            </tr>

            <tr>
              <td rowspan="6" class="ct">模型回测</td>
              <td>专业测试报告</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>回测资金曲线(信号复盘)</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>枚举法参数优化</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>遗传算法参数优化</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>多模型组合回测</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>期货多因子分析</td>
              <td>√</td>
              <td>√</td>
            </tr>



            <tr>
              <td rowspan="2" class="ct">页面盒子 <br>(半自动运行)</td>
              <td>信号监测</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>跟随信号自动下单</td>
              <td>√</td>
              <td>√</td>
            </tr>


            <tr>
              <td rowspan="8" class="ct">模组<br>(全自动运行)</td>
              <td>资金管理</td>
              <td><sup class="heng"></sup></td>
              <td>√</td>
            </tr>
            <tr>
              <td>头寸管理/风控</td>
              <td><sup class="heng"></sup></td>
              <td>√</td>
            </tr>
            <tr>
              <td>产品申购/赎回管理</td>
              <td><sup class="heng"></sup></td>
              <td>√</td>
            </tr>
            <tr>
              <td>运行收益分析统计</td>
              <td><sup class="heng"></sup></td>
              <td>√</td>
            </tr>
            <tr>
              <td>策略运行日志</td>
              <td><sup class="heng"></sup></td>
              <td>√</td>
            </tr>
            <tr>
              <td>远程服务器运行监控</td>
              <td><sup class="heng"></sup></td>
              <td>√</td>
            </tr>
            <tr>
              <td>运行收益曲线</td>
              <td><sup class="heng"></sup></td>
              <td>√</td>
            </tr>
            <tr>
              <td>日志邮件发送</td>
              <td><sup class="heng"></sup></td>
              <td>√</td>
            </tr>







            <tr>
              <td rowspan="2" class="ct">其他功能</td>
              <td>云端止损单</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>账户风控</td>
              <td>√</td>
              <td>√</td>
            </tr>










            <tr>
              <td rowspan="3" class="ct">售后服务</td>
              <td>专属的金融工程师</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>辅助编写模型</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <tr>
              <td>文文通即时服务</td>
              <td>√</td>
              <td>√</td>
            </tr>
            <!-- <tr> -->
              <!-- <td rowspan="38" style="width:20px;text-align:center;padding:5px 15px;border-bottom:1px solid #bcbaba">行情列表</td> -->
              <!-- <td rowspan="14" style="width:150px;" class="ct">K线/技术指标数据</td>
              <td>获取股票/指数/可转债的日K线数据</td>
              <td rowspan="14">提供沪深股票、可转债、指数、期货的日K线数据、停牌信息、交易日列表，以及股票、股票/可转债指数的常用技术指标数据。</td>
              <td rowspan="14" class="ct" >√</td>
            </tr> -->
           
           
           
           
           
           
            
           
            <tr>
              <td colspan="2" style="text-align:right">软件服务费</td>
              <td style="padding: 10px 0px;text-align:center;color: #287cee;">
                <span style="color: #287cee;font-weight: bold;font-size: 18px;margin-left: 11px;">{{webMarketPrice.monthprice}}</span>元/月/账号<span @click="showiframe(1)" style="cursor:pointer;text-decoration: underline;margin-left:10px">去购买</span><br>
                <span style="color: #287cee;font-weight: bold;font-size: 18px;">{{webMarketPrice.quarterprice}}</span>元/季/账号<span @click="showiframe(2)" style="cursor:pointer;text-decoration: underline;margin-left:10px">去购买</span><br>
                <span style="color: #287cee;font-weight: bold;font-size: 18px;">{{webMarketPrice.price1}}</span>元/年/账号<span @click="showiframe(3)" style="cursor:pointer;text-decoration: underline;margin-left:10px">去购买</span><br>
                
              </td>
              <td style="padding: 10px 0px;text-align:center;color: #287cee;"><span style="color: #287cee;font-weight: bold;font-size: 18px;">{{webMarketPrice.price2}}</span>元/年/账号<span @click="showiframe()" style="cursor:pointer;text-decoration: underline;margin-left:10px">去购买</span> </td>
              <!-- <td style="color: #287cee;font-weight: bold;font-size: 18px;padding: 10px 0px;text-align:center">8700（元/年/账号） </td> -->
            </tr>
          </tbody>
        </table>
        <div class="bmodel pbyBtn" style="border:none;background:none;margin-left:-25px;">
            <!-- <p class="care" style="margin: 10px 0 0 30px;font-size: 16px;">*注：</p>
            <p class="care" style="font-size: 14px;">1.8E套餐季付优惠价1500元/季，年付优惠价4500元/年</p> -->
            <!-- <p class="care" style="font-size: 14px;">2.历史数据服务只向机构销售，通过审核后签署特别合同 <span class="care_a e_care_a">点击申请</span>；</p> -->
            <p class="care" style="font-size: 14px;">*注：中国金融期货数据及国内股票数据仅限在中国大陆范围内查看使用;</p>
            <!-- <p class="care" style="font-size: 14px;">4.如需在境外查看中金一档数据，需付数据使用费。</p> -->
            
        </div>
        <!-- <div class="bmodel kongb1" style="width:868px"></div> -->
        <div class="bmodel pbyBtn" style="border:1px dashed #a0a0a0;background:#fffeec">
            <p class="care" style="font-size: 14px;margin: 10px 0 0 30px;margin-left:5px;"><img src="https://www.wenhua.com.cn/static/images/tanhao1.png" style="margin: 0 5px 0 0;">声明</p>
            <p class="care" style="font-size: 14px;margin-left:5px;">1.按照监管新规，新客户必须报备通过以后才能程序化交易，请先向期货公司报备，再购买软件;</p>
            <p class="care" style="font-size: 14px;margin-left:18px;margin-top: -5px;">登录软件后，在菜单 量化－>程序化报备，也可向部分期货公司报备。</p>
            <p class="care" style="font-size: 14px;margin-left:5px;">2.服务期内我司有权对其他数据、信息、功能进行增减等调整;</p>
            <p class="care" style="font-size: 14px;margin-left:5px;">
                3.你可能遇到的下列情形(包括但不限于)恕我司不负责解决，并不退还剩余费用：<br />
                (1)因电脑硬件配置低或操作系统版本过低，无法满足新版要求；<br />
                (2)开户的期货公司，不再支持星格软件。
            </p>
        </div>
        <div style="height:90px;display: flex;flex-direction: row;justify-content: space-between;align-items:center;">
          <div style="float:left;margin-top:22px;font-size:14px;" class="buy_tel">咨询电话：<common-data name="serviceTel"/></div>
        </div>
      </div>
    </div>
    <Pay v-if="showpay" :src="src" @close="close"></Pay>
  </div>
</template>

<script setup>
import axios from 'axios'
import {ref,onMounted} from 'vue'
import Pay from './Pay.vue'
const showpay = ref(false)
const src =ref('')
const webMarketPrice=ref({
        price1:0,
        monthprice:0,
        quarterprice:0,
        price2:0
      })
const setPrice=function(){
      axios.get('https://pay.wenhua.com.cn/api/Product/Detail?id=122').then((res) => {
          if (res.data.status) {
            webMarketPrice.value.price1 = res.data.data.price
            webMarketPrice.value.monthprice = res.data.data.monthprice
            webMarketPrice.value.quarterprice = res.data.data.quarterprice
          } else {
            alert(res.data.message)
          }
        });
        axios.get('https://pay.wenhua.com.cn/api/Product/Detail?id=1').then((res) => {
          if (res.data.status) {
            webMarketPrice.value.price2 = res.data.data.price
            
          } else {
            alert(res.data.message)
          }
        });
}
setPrice()
const showiframe = function(num){
  if(!!num){
    src.value='https://pay.wenhua.com.cn/#/iframePay/122?from=starquant&paytype='+num
  }
  else{
    src.value='https://pay.wenhua.com.cn/#/iframePay/1?from=starquant'
  }
  showpay.value=true
}
const close = function(message){
  if(message.data=='close'){
    showpay.value = false
  }
}
</script>

<style scoped>
.buy_text{
    /* padding:0 30px;
    padding-top: 35px; */
    /* text-indent: 2em; */
    font-size: 14px;
    color: #737373;
    padding-bottom: 50px;
    letter-spacing: 1px;
    line-height: 25px;
    /* padding-right: 60px; */
}
.table1 {
    /* width: 100%; */
}
.table1 tr td:last-of-type{
    text-align: center;
}
.table1 tr td:nth-last-of-type(2){
    text-align: center;
}
.table1 thead tr {
  background: url(../assets/img/table_title.png)no-repeat center;
  background-size: 100% 100%; 
}
.table1 td,.table1 th{
  padding: 4px 8px;
  vertical-align: middle;
  line-height: 19px;
}
.table1 th{
  text-align: center;
  /* background: #4479ab; */
  border: 1px solid white;
  color: white;
  font-size: 16px;
  padding:8px 0;
}
.table1 td{
  border: 1px solid #cccccc;
}
/* .table1 td:last-child{
  text-align: center;
  
} */
.ct {
  text-align: center !important;
}



.tipsss{
  border:1px solid #cccccc;
  border-top:none;
  padding: 20px;
}
.zhushi {
  line-height: 24px;
  font-size: 14px;
  color: #666;
  letter-spacing: 1px;
  /* text-indent: 2em; */
  /* padding-left: 37px; */
}
.num_text {
  color: #287cee;
  font-size: 16px;
  /* margin-left: 20px; */
}
.daozhuan{
      transform: rotateX(180deg);
}
.href {
  color: #3888ff;
  /* text-decoration: underline; */
  cursor: pointer;
  font-size: 14px;
  margin-left: 20px;
  vertical-align: middle;
}
.yuyue {
  /* height: 330px; */
  background: #f0f3fc;
  padding: 20px 125px;
  margin-bottom: 10px;
  width: 500px;
}
.yuyue input {
  margin: 10px 0;
}
.yuyue h3 {
  text-align: center;

  font-size: 20px;
  line-height: 25px;
  color: #7f8080;
  padding-top: 15px;
}
.yuyue p {
  font-size: 16px;
  line-height: 30px;
  color: #287cee;
  margin-bottom: 15px;
}
.yuyue input {
  height: 30px;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  padding-left: 10px;
  outline: none;
  border: none;
  font-size: 16px;
  width: 320px;
}
.yuyue h4 {
  width: 85px;
  letter-spacing: 5px;
  line-height: 40px;
  height: 40px;
  margin-left: 10px;
  display: inline-block;
  text-align: right;
  padding-right: 8px;
}
.shengfen {
  width: 140px;
  display: inline-block;
  height: 30px;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  line-height: 30px;
  padding-left: 10px;
  letter-spacing: 2px;
}
.selectt {
  width: 30px;
  height: 30px;
  background: url(../assets/img/xia.png) no-repeat;
  color: white;
  float: right;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.xiala {
  width: 150px;
  float: right;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  height: 100px;
  overflow-y: scroll;
}
.xiala li {
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  overflow: hidden;
}
.xiala li:hover {
  background: #f0f3fc;
}
.sub {
  width: 100px;
  background: #287cee;
  border-radius: 10px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  margin: 0 auto;
  color: white;
  margin-top: 15px;
  cursor: pointer;
}
/* input:-internal-autofill-selected{
    background: white;
  } */
input:-internal-autofill-selected {
  background: black;
}
 .care {
    font-size: 13px;
    /* color: #2f2f2f; */
    margin-left: 30px;
    line-height: 23px;
}
.pbyBtn {
    width: 794px;
    border-bottom: 1px solid #a0a0a0;
    border-right: 1px solid #a0a0a0;
    border-top: 0;
    position: relative;
    background: #f9f5e0;
    padding-bottom: 15px;
    padding-top: 8px;
}
.rnowBuy {
    display: block;
    position: absolute;
    top: 30px;
    right: 0px;
    width: 140px;
    height: 43px;
    border: 1px solid #fc8d1f;
    border-radius: 5px;
    color: #fc8d1f;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 43px;
    text-decoration: none;
    background: #fefefe;
}



.model_table{
        border-collapse: collapse;
        font-size: 14px;
        line-height: 20px;
        width: 100%;
    }
    .model_table thead tr {
        background: url(../assets/img/table_title.png)no-repeat center;
        background-size: 100% 100%; 
    }
    .model_table.pack{
        text-align: center;
    }

    .model_table th{
        border: 1px solid white;
        vertical-align: middle;
    }
    .model_table td{
        border: 1px solid #cccccc;
        vertical-align: middle;
    }


    .model_table th{
        height: 84px;
        font-size: 16px;
        color: #fff;
        text-align:center;
    }

    .model_table td{
        padding: 5px 8px;
    }

    .model_table td a{
        border-bottom: 1px solid  #333;
        color: #333;
        text-decoration: none;
    }
    .model_table td a:hover{
        color: blue;
        border-bottom: 1px solid  blue;
        text-decoration: none;
    }
    .model_table td span{
        font-weight: 700;
        font-size: 20px;
        line-height: 30px;
    }

    .model_table.pack td:nth-last-child(2){
        text-align: left;
    }

    /* .model_table.pack td:nth-last-child(2),
    .model_table.pack td:nth-last-child(2) span{
        background: #faf6f8;
        color: #960f03;
    } */

    .model_table.pack td:nth-last-child(1),
    .model_table.pack td:nth-last-child(1) span{
        /* background: #f5f5f9;
        color: #0b026f; */
    }

    .model_table.pack td:nth-last-child(2){
        padding-left: 8px;
    }

    .model_table.table2 td:nth-last-child(1){
        padding-left: 8px;
        /* background: #f5f5f9; */
    }
    .model_table.table2 td:nth-last-child(2){
        padding-left: 8px;
    }
    sup {
          font-size: 12px;
          position: relative;
          top: -5px;
          left: -3px;
    }
    td:has(.heng){
    vertical-align: middle;
    }
    sup.heng {
      display: inline-block;
      height: 0;
      width: 10px;
      border-bottom: 1px solid #737373;
      position: relative;
      top: -5px;
    }
</style>